<script>
	import { onMount } from 'svelte';
	import { film, jwt } from './store.js';
	import { navigate } from 'svelte-navigator';
  
	let data = {};
  
	const getMovie = async () => {
		// Add the token to the request
		const response = await fetch('https://api.abittel.fr/movie/random', {
			headers: {
				'Authorization': 'Bearer ' + $jwt
			}
		});

		if (response.status === 401) {
			localStorage.removeItem('token');
			$jwt = '';
			navigate('/login');
			return;
		}

		data = await response.json();
		$film = data;
	};
	onMount(async () => {
		await getMovie();
	});
  </script>
  
   
<div class="film">
	{#if data.title && data.image}
		<div class="title">
			<h1 on:click={() => navigate('/links')}>{data.title}</h1>
			<button class="button" on:click={getMovie}>
				new
			</button>
		</div>
		<img src="data:image/jpg;base64,{data.image}" alt={data.title} on:click={() => navigate('/links')}/>
	{/if}
</div>


<style>
	.film {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
	}
  
	img {
		width: 50vw;
		height: auto;
		cursor: pointer;
		@media (max-width: 768px) {
			width: 99vw;
		}
	}
	 
	.title {
		display: flex;
		align-items: center;
		justify-content: center;

		@media (max-width: 768px) {
			font-size: 0.75rem;
			text-align: center;
		}
	}

	.title h1 {
		margin-right: 1rem;
		cursor: pointer;
	}

	.button {
		margin: 0.5rem;
		padding: 0.5rem 1rem;
		cursor: pointer;
		text-decoration: none;
        margin: 50px 15px;
        padding: 10px 20px;
        border-radius: 5px;
        transition: background-color 0.3s ease;
        background-color: #40466d;

		border: none;

		color: #ffffff;
	}

	.button:hover {
		background-color: #354190;
	}

</style>